import React from 'react'
import InfoBlock from '../../shared/infoBlock'
import Title from '../../shared/title'
import ArrowButton from '../../shared/arrowButton'
import Img from 'gatsby-image'
import { isNarrowDesktop } from '../../../media-queries'

export default class Family extends React.Component {
  state = {
    height: getHeight(),
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.updateHeight)
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateHeight)
    }
  }

  setHeight = () => {
    this.setState({ height: getHeight() })
  }

  updateHeight = () => {
    if (!isNarrowDesktop()) {
      this.setHeight()
    }
  }

  render() {
    const greenTitle = this.props.title.split(' ').pop()
    const blackTitle = this.props.title.substr(
      0,
      this.props.title.length - greenTitle.length
    )
    return (
      <div
        style={{
          display: 'flex',
          height: this.state.height,
          minHeight: 600,
          ...this.props.style,
        }}
      >
        <div
          style={{
            margin: 'auto',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div
              style={{
                padding: '0 10vw 0 5rem',
                width: '50vw',
              }}
            >
              <InfoBlock
                title={blackTitle}
                bigTitle={true}
                accentColor={'#8CBD8C'}
                extra={greenTitle}
                text={this.props.prospectives.internal.content}
                style={{ marginBottom: '5rem' }}
              />
              <ArrowButton
                route={'/student-stories'}
                text={"Read our students' stories"}
              />
            </div>
            <div
              style={{
                padding: '1rem 5rem 6rem 0',
                width: '50vw',
              }}
            >
              <Img sizes={this.props.image.sizes} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const getHeight = () => {
  if (window) {
    if (isNarrowDesktop()) return 750
    else return window.innerHeight - 45
  }
}



// WEBPACK FOOTER //
// ./src/components/homepage/family/index.js